import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AppConfig} from "../../modules/base/app-config";
import {ConfigService} from "../../modules/base/config.service";
import {PortalApiService} from "../../modules/record/portal-api.service";

@Component({
  selector: 'super-user-selector',
  templateUrl: './super-user-selector.component.html',
  styleUrls: ['./super-user-selector.component.scss']
})
export class SuperUserSelectorComponent implements OnInit {
  constructor(
    private config: ConfigService<AppConfig>,
    private router: Router,
    private apiService: PortalApiService
  ) {
  }

  customerList: string[] = [];

  selectedCustomer: string = "alitheon";

  ngOnInit() {
    this.selectedCustomer = this.config.getConfig().customerName;
    this.getCustomers();
  }

  getCustomers(): void {
    this.apiService.getCustomerList().subscribe(customers => {
      this.customerList = customers.map(customer => customer.name);
    });
  }

  onCustomerChange() {
    if (this.selectedCustomer) {
      // update the running config with the selected customer
      let updatedConfig = this.config.getConfig();
      updatedConfig.customerName = this.selectedCustomer;
      this.config.setConfig(updatedConfig);
    }
    this.navigateHome();
  }

  navigateHome(): void {
    this.router.navigateByUrl('').then(r => true);
  }
}
